/* eslint-disable */
import 'jcarousel';
import Search from '@/js/common/Domain/Service/Search';
import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import ThFavoritesView from '@/js/desktop/components/thFavorites/thFavorites';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import HotelsRepository from '@/js/common/Domain/Repository/Hotels';
import HotelFactory from '@/js/common/Domain/Factory/Hotel';
import HotelsMapView from '@/js/desktop/components/hotelsMap/HotelsMap';
import SearchRequestFactory from '@/js/common/Domain/Factory/SearchRequest';

import HotelOnMapView from '@/js/desktop/components/hotelOnMap/hotelOnMap';
import hotelToNewFormatAdapter from '@/js/common/Domain/Repository/service/hotelToNewFormatAdapter';

const searchService = new Search();

const hotelOnMapView = new HotelOnMapView();
const currentTourCritria = new TourCriteriaObjectValue();

const mapHotel = Backbone.View.extend({
    el: '<div class="serpHotel serpHotel_new"></div>',
    template: null,
    events: {
        'click .goToHotelWithId': 'goToHotelWithId',
        'click .goToHotel': 'goToHotel',
        'mousedown a:not(.goto-ua-page)': 'hrefUrl',
    },
    generateImagesHtml({ cover, photos }) {
        let html = '';
        const images = [].concat(
            cover || [],
            photos || [],
        );

        if (images?.length) {
            images.forEach((photo) => {
                html += `<li><a href="#" style="background-image: url(${imageProxy(photo, {
                    width: 300,
                    height: 220,
                })})"></a></li>`;
            });
        }

        return html;
    },
    getImages() {
        let imagesHtml = this.model.get('imagesHtml');

        if (!imagesHtml) {
            imagesHtml = this.generateImagesHtml({
                cover: this.model.get('cover'),
                photos: this.model.get('photos'),
            });
            this.model.set('imagesHtml', imagesHtml);
        }

        $('.imagesHtml', this.$el).html(imagesHtml);
        $('.js-images-carousel', this.$el).jcarousel('reload', {
            animation: 'fast',
            vertical: false,
        });
    },

    render() {
        const data = this.model.toJSON({ computed: true });
        data.originalHotelObject = this.model;

        hotelOnMapView.reRender({
            data,
            $el: this.$el,
            parentModel: this.model,
            collectionView: this.collectionView,
        });

        $('.js-images-carousel', this.$el)
            .jcarousel({
                list: '.list',
                items: 'li',
                wrap: 'both',
                vertical: false,
            });

        $('.js-images-carousel-control-prev', this.$el)
            .jcarouselControl({
                target: '-=1',
            });

        $('.js-images-carousel-control-next', this.$el)
            .jcarouselControl({
                target: '+=1',
            });

        this.data = data;
    },

    reRender() {
        this.render();
    },

    initSubscribes() {
        this.model.on('change:minPrice', $.proxy(this.reRender, this));
        this.model.on('change:tourProducts', $.proxy(this.reRender, this));
    },
    initModel() {
        this.model.set('searchData', mapSearchPageModel.get('searchData'));
    },
    initSubViews() {
        if (this.model.get('tourProducts').length) {
            new ThFavoritesView({
                model: this.model,
                searchPageModel: this.collectionView.model,
                el: $('.addToFavorites', this.$el),
            });
        }
    },
    initialize(options) {
        this.collectionView = options.collectionView;
        this.template = options.template;

        this.render();
        this.initSubscribes();

        this.getImages();
        this.initSubViews();
        this.initModel();
    },
    hrefUrl(event) {
        const urlParams = toRouterHotelHydrator({
            tourCriteria: mapSearchPageModel.get('searchData'),
            sid: searchSessionService.getSearchId(),
        });
        const hotelUrl = `/goto/hotel/${this.model.get('id')}`;
        const target = '_blank';
        const $target = $(event.currentTarget);

        $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
        $(event.currentTarget).attr('target', target);
    },
    goToHotel(event) {
        const tourCriteria = this.model.get('tourProducts').at(0).get('tourCriteria');
        const urlParams = toRouterHotelHydrator({
            tourCriteria,
            sid: searchSessionService.getSearchId(),
        });
        const target = '_blank';
        const hotelUrl = `/goto/hotel/${this.model.get('id')}`;

        if (this.model.hotelType && this.model.hotelType === 'current') {
            $(document).scrollTop($('#hotelToursList')?.offset()?.top - 100);
        } else {
            window.open(`${hotelUrl}#?${$.param(urlParams)}`, target);
        }

        return false;
    },
});

var mapSearchPageModel = new (Backbone.Epoxy.Model.extend({
    defaults: {
        searchData: currentTourCritria,
        beforeToursLoading: true,
        loadingInProgress: false,
        viewMode: 'map',
        syncHotels: null,
        syncTourProducts: null,
        sortStrategy: 'recommend',
    },
    computeds: {
        filteredHotels() {
            return this.get('syncHotels');
        },
        minPrice() {
            const hotels = this.get('syncHotels');
            let minPrice = Infinity;

            if (hotels && hotels.length) {
                hotels.each((hotel) => {
                    const price = hotel.get('minPrice');
                    if (price < minPrice) {
                        minPrice = price;
                    }
                });
                return minPrice;
            }
            return false;
        },
    },
}))();

const hotelsCollection = new HotelsRepository();

const MapHotelsSearchView = Backbone.Epoxy.View.extend({
    model: mapSearchPageModel,
    collection: hotelsCollection,
    itemView: mapHotel,
    currentSearchModel: new TourCriteriaObjectValue(),
    currentHotel: null,
    parentView: null,

    initialize(options) {

		if(appConfig.coordinates) {
			this.currentHotel = new HotelFactory(_.extend({}, hotelToNewFormatAdapter(window.appConfig.hotelInfo), {
				coords: window. appConfig.coordinates,
            }));
            this.currentHotel.hotelType = 'current';
            this.parentView = options.parentView;
            this.parentView.model.set('mapHotelsSearchModel', this.model);

            this.initMapOpenEvent();
        }
    },
    initMapOpenEvent() {
        const self = this;
        const $hideBtn = $('.js-hide-map-btn');
        const $openMap = $('#openMap');
        let mapOpened = false;

        $openMap.on('click', (event) => {
            $openMap.hide();
            $hideBtn.show();

            $('#showMapContainer').slideDown('fast', !mapOpened ? () => {
                self.initEvents();
                self.tourSearchCriteriaChanged();
                mapOpened = true;
            } : '');
        });
        $hideBtn.on('click', () => {
            $('#showMapContainer').slideUp('fast');
            $hideBtn.hide();
            $openMap.show();
        });
    },
    initEvents() {
        this.listenTo(this.parentView.model, 'change:tourSearchCriteria', $.proxy(this.tourSearchCriteriaChanged, this));
    },
    openCurrentHotelMap() {
        let hotels;

		this.collection.reset();
		hotels = new HotelsRepository(this.currentHotel);
		this.model.set('syncHotels', hotels);
		this.model.trigger('change:filteredHotels', null, this.model.get('filteredHotels'));
		this.model.set('loadingInProgress', false);
		this.initMap();
	},
	tourSearchCriteriaChanged() {
        let tourSearchCriteria = this.parentView.model.get('tourSearchCriteria');

        if (tourSearchCriteria) {
            tourSearchCriteria = tourSearchCriteria.clone();
            tourSearchCriteria.set('hotels', new HotelsRepository());

            this.currentSearchModel.set(tourSearchCriteria.attributes);
            this.goSearch();
        } else {
            this.openCurrentHotelMap();
            this.hotelsMap.openFirstHotelInfo();
        }
    },

    goSearch() {
        const searchServiceParamsCollection = [];
        const tourCriteria = this.currentSearchModel;
        const self = this;

        if (tourCriteria.isValid() && tourCriteria.get('countries') && tourCriteria.get('countries').length) {
            this.model.set('searchData', tourCriteria);
            searchServiceParamsCollection.push(new SearchRequestFactory(tourCriteria, 'sync'));

            self.model.set('loadingInProgress', true);
            this.openCurrentHotelMap();
            this.hotelsMap.initMap(() => {
                self.hotelsMap.openFirstHotelInfo();
            });
            searchService.getOffersData({
                requests: searchServiceParamsCollection,
                callback: {
                    sync(hotels, tourProducts) {
                        const currentHotel = hotels.findWhere({ id: window.appConfig.hotelInfo.id });
                        hotels.each((hotel) => {
                            hotel.initHotelOptions();
                        });

                        if (hotels.length > 0) {
                            self.collection.reset();
                        }

                        if (currentHotel) {
                            currentHotel.hotelType = 'current';
                            hotels.remove(currentHotel, { silent: true });
                            hotels.unshift(currentHotel, { silent: true });
                        } else {
                            hotels.unshift(self.currentHotel, { silent: true });
                        }

                        self.hotelsMap.initMap(() => {
                            self.hotelsMap.tryOpenFirstHotelInfo();
                        });
                        self.model.set('syncHotels', hotels, {
                            setFirstOnCenter: true,
                        });
                        self.model.set('syncTourProducts', tourProducts);
                        /*self.model.trigger('change:filteredHotels', null, self.model.get('filteredHotels'));*/
                        self.model.set('loadingInProgress', false);
                    },
                },
            });
        }
    },

    initMap() {
        if (!this.hotelsMap) {
            this.hotelsMap = new HotelsMapView({
                currentHotel: this.currentHotel,
                hotelMapView: hotelOnMapView,
                searchPageModel: this.model,
                HotelsList: mapHotel,
            });
        }
    },
});

export default MapHotelsSearchView;
